
export default function getCurrentLocale(localeOptions, locale, defaultString) {
    let locales;
    if (localeOptions && localeOptions.asMutable) {
        locales = localeOptions.asMutable() || localeOptions;
    }
    if (!locales || !Array.isArray(locales)) {
        console.error('Locale options will not render correctly! Expecting an array of seamless immutable objects containing both [name] and [lang] keys!');
        locales = [];
    }

    let currentLocale = defaultString;
    let activeLocale;
    locales.forEach((l) => {
        if (l.lang === locale) {
            activeLocale = l;
        }
    });

    if (locale && activeLocale) {
        currentLocale = activeLocale.name;
    }

    locales = locales.sort((localeA, localeB) => {
        const a = localeA.lang.toLowerCase();
        const b = localeB.lang.toLowerCase();
        if (a > b) return 1;
        if (a < b) return -1;
        return 0;
    });

    return { currentLocale, locales };
}



// WEBPACK FOOTER //
// ./app/scripts/utils/localeUtils.js